import { $http } from "@/utils/http";
import { SET_LOADING_FEEDBACK, SET_CONTACTS, SET_CONTACTS_LOADING } from "../mutation-types";

import { SEND_FEEDBACK, GET_CONTACTS } from "../action-types";

const state = {
    loadingFeedback: false,
    contacts: null,
    loadingContacts: false,
};

const getters = {
    loadingFeedback: state => state.loadingFeedback,
    contacts: state => state.contacts,
    loadingContacts: state => state.loadingContacts,
};

const actions = {
    [SEND_FEEDBACK]: async ({ commit }, payload) => {
        commit(SET_LOADING_FEEDBACK, true);
        try {
            return await $http.post("v1/feedbacks", payload);
        } catch (e) {
            console.log();
            throw e;
        } finally {
            commit(SET_LOADING_FEEDBACK, false);
        }
    },
    [GET_CONTACTS]: async ({ commit }) => {
        commit(SET_CONTACTS_LOADING, true);
        try {
            const response = await $http.get("v1/contact-info");
            commit(SET_CONTACTS, response);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_CONTACTS_LOADING, false);
        }
    },
};

const mutations = {
    [SET_LOADING_FEEDBACK](state, status) {
        state.loadingFeedback = status;
    },
    [SET_CONTACTS](state, data) {
        state.contacts = data;
    },
    [SET_CONTACTS_LOADING](state, status) {
        state.loadingContacts = status;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
